<div data-cy="add-user-dialog">
  <div mat-dialog-title class="header">
    {{ title }}
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <form [formGroup]="userForm" class="new-user-form">
      <mat-form-field class="full-width">
        <mat-label>Email</mat-label>
        <input #email formControlName="email" id="email" matInput data-cy="email-input" name="email" type="text" />
        @if (emailErrorMessage) {
          <mat-error>{{ emailErrorMessage }}</mat-error>
        }
        @if (errorMessage) {
          <mat-error>
            {{ errorMessage }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Role:</mat-label>
        <mat-select formControlName="role" data-cy="select-role">
          <mat-option value="SuperAdmin">Super Admin</mat-option>
          <mat-option value="Admin">Admin</mat-option>
          <mat-option value="FinanceAdmin">Finance Admin</mat-option>
          <mat-option value="ReadAdmin" [disabled]="disableUserRoleOptions">
            Read Admin {{ disableUserRoleOptions ? '(disabled)' : '' }}
          </mat-option>
          <mat-option value="Landowner" [disabled]="disableUserRoleOptions">
            Landowner {{ disableUserRoleOptions ? '(disabled)' : '' }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox data-cy="is-active-checkbox" formControlName="isActive">Is Active</mat-checkbox>
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-stroked-button color="primary" mat-dialog-close data-cy="cancel-button">CANCEL</button>
    <button
      (click)="submitUser()"
      [disabled]="userForm.invalid || userForm.pristine"
      color="primary"
      data-cy="submit-button"
      mat-raised-button>
      {{ primaryButtonText }}
    </button>
  </div>
</div>
